import { useParams } from "react-router-dom";
import UnifiedRevenueDashboard from "@/components/UnifiedRevenueDashboard";
import GoalDeltaIndicator from "@/components/GoalDeltaIndicator";
import KeyboardShortcuts from "@/components/KeyboardShortcuts";
import LoadingState from "@/components/LoadingState";
import ErrorState from "@/components/ErrorState";
import GoalCompletionModal from "@/components/GoalCompletionModal";
import { useDashboardData } from "./dashboard/useDashboardData";
import { progressStatusFor } from "./dashboard/dashboardModel";
import { DashboardWelcome } from "./dashboard/DashboardWelcome";
import { DashboardGrid } from "./dashboard/DashboardGrid";

const Dashboard = ({ streamUpdates, setStreamUpdates, streamPaused, setStreamPaused, currentInstance, onOpenTargeting }) => {
  const { userId } = useParams();
  const d = useDashboardData(userId, currentInstance);

  if (userId === "new") return <DashboardWelcome />;
  if (d.loading) return <div className="min-h-screen bg-[#0a0e17]"><LoadingState message="Loading command module..." /></div>;
  if (d.error) return <div className="min-h-screen bg-[#0a0e17]"><ErrorState message={d.error} onRetry={d.refresh} /></div>;

  const m = d.effectiveMetrics;
  const progressPercentage = m?.progressPercentage || 0;
  const stream = { updates: streamUpdates, setUpdates: setStreamUpdates, paused: streamPaused, setPaused: setStreamPaused };

  return (
    <div className="min-h-screen bg-[#0a0e17]" data-testid="dashboard">
      <GoalCompletionModal isOpen={d.showGoalModal} onClose={d.closeGoalModal} revenueGoal={m?.revenueGoal || 0} />
      <KeyboardShortcuts />
      <header className="border-b border-gray-800/50 bg-[#0a0e17]/95 backdrop-blur-lg sticky top-0 z-50">
        <div className="container mx-auto px-6 py-3" />
      </header>
      <div className="container mx-auto px-6 py-8">
        <div className="mb-8">
          <UnifiedRevenueDashboard goal={m?.revenueGoal || 0} current={m?.currentRevenue || 0} status={progressStatusFor(progressPercentage)}
            progressPercentage={progressPercentage} goalEndDate={d.user?.goalEndDate} userId={userId} instanceName={currentInstance?.name} />
        </div>
        <DashboardGrid userId={userId} onRefresh={d.refresh} currentInstance={currentInstance} onOpenTargeting={onOpenTargeting} stream={stream} />
      </div>
      <GoalDeltaIndicator userId={userId} goalOverride={m?.revenueGoal} currentOverride={m?.currentRevenue} />
    </div>
  );
};

export default Dashboard;
